import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SharedService } from 'app/shared/services/shared.service';
import { SortService } from 'app/core/services/sort.service';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { LendersService } from '../../services/lenders.service';
import { LendersModel } from 'app/lenders/models/lenders.model';
import { debounceTime } from 'rxjs/operators';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';

@Component({
  selector: 'app-lenders',
  templateUrl: './lenders-list.component.html',
  styleUrls: ['./lenders-list.component.css']
})
export class LendersListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    lenders: LendersModel[];
    lendersList: LendersModel[];
    filterForm: FormGroup;
    filterTextControl: FormControl;
    lastSort: ColumnSortedEvent;

    constructor(
        private _router: Router,
        private lendersService: LendersService,
        private fb: FormBuilder,
        private sortService: SortService,
        private sharedService: SharedService
    ) { }

    ngOnInit() {
        this.headerTitle = { title: 'Lenders' }

        this.lendersService.getAll().subscribe(
            lenders => {
                this.lenders = lenders;
                this.lendersList = lenders;
            },
            error => this.errors = error.errorList
        );

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.lendersList = this.sortService.filterAndSortlist(this.lenders, newValue, this.lastSort);
        });
  }

}
